import React, { useState, useEffect } from "react";

import "@brainhubeu/react-carousel/lib/style.css";

import "./Form.scss";

import ArrowYellow from "../../images/icon/arrow-yellow.svg";

import { FiLoader } from "react-icons/fi";
import swal from "sweetalert";
import { pwrCheckout } from "../../Api/pwr";

import { api } from "../../Api/app";

import Logo from "../../images/forms/logo-vida.svg";

import InputMask from "react-input-mask";
import { useSinglePrismicDocument } from "@prismicio/react";
import { FormContent } from "../../Components/FormContent";

export default function Index(props) {
  const [stepLoad, setstepLoad] = useState(false);
  const [menuPlano, setmenuPlano] = useState("");

  const [camposFormulario, setCamposFormularios] = useState({
    nome: "",
    telefone: "",
    email: "",
    plano: "",
    mensagem: "",
  });

  const superHealthPageGraphQuery = `{
        pagina_super_saude{
            form_title
            form_subtitle
            form_img
            form_img_mobile
             plans{
              plan_link{
              ...on plano_saude{  
                  price
              }
            }
          } 
        }
    }`.replace(/^ +| +$/gm, "");
  const [superHealthPageContent] = useSinglePrismicDocument(
    "pagina_super_saude",
    {
      graphQuery: superHealthPageGraphQuery,
    }
  );

  const propsFormContent = {
    imgURL: superHealthPageContent?.data.form_img?.url
      ? superHealthPageContent?.data.form_img.url
      : "#",
    imgAlt: superHealthPageContent?.data.form_img?.alt
      ? superHealthPageContent?.data.form_img.alt
      : "",
    imgMobileURL: superHealthPageContent?.data.form_img_mobile?.url
      ? superHealthPageContent?.data.form_img_mobile.url
      : "#",
    imgMobileAlt: superHealthPageContent?.data.form_img_mobile?.alt
      ? superHealthPageContent?.data.form_img_mobile.alt
      : "",
    title: superHealthPageContent?.data.form_title[0]?.text
      ? superHealthPageContent.data.form_title[0].text
      : "",
    subtitle: superHealthPageContent?.data.form_subtitle[0]?.text
      ? superHealthPageContent.data.form_subtitle[0].text
      : "",
  };

  const planPrices = superHealthPageContent?.data?.plans?.map((plan) => {
    return plan.plan_link?.data.price[0]?.text
      ? parseFloat(plan.plan_link?.data.price[0]?.text.replace(",", "."))
      : 0;
  });

  useEffect(() => {
    const query = new URLSearchParams(props.location.search);
    let plano_url = query.get("plano");
    if (plano_url) {
      let opcoes = {
        1: "PLANO_SAUDEESSENCIAL",
        2: "PLANO_SAUDEPLUS",
        3: "PLANO_SAUDEPREMIUM",
      };
      if (opcoes[plano_url]) setmenuPlano(opcoes[plano_url]);
    }
  }, []);

  async function handleSend(event) {
    if (event) event.preventDefault();

    if ("Plano" == menuPlano || "" == menuPlano) {
      swal({
        title: " ",
        text: "Selecione seu plano",
        showCancelButton: false,
        showConfirmButton: false,
      });
      return;
    }

    let slsmnId = null;
    let slsmnNwId = null;
    swal({
      title: " ",
      text: "Enviado com sucesso, você será direcionado ao checkout para concluir sua proteção!",
      showCancelButton: false,
      showConfirmButton: false,
    });

    let response = await pwrCheckout.post("/qttnStep1?plano=" + menuPlano, {
      h: "sp beneficios507",
      slsmnId: slsmnId,
      slsmnNwId: "NrP2PKql",
      name: camposFormulario.nome,
      email: camposFormulario.email,
      phone: camposFormulario.telefone,
    });

    window.location.href =
      "https://crm.superbeneficios.com/checkout?h=" + response.data.back;
  }

  async function handleSend2(event) {
    event.preventDefault();

    var data = camposFormulario;

    setstepLoad(true);

    var response = await api.post("/form-saude", data);

    if (response.data.error == true) {
      alert(response.data.message);
    } else {
      swal("Enviado com sucesso!");
    }

    setTimeout(function () {
      setstepLoad(false);
    });
  }

  function changeInputMult(e) {
    var meusdados = camposFormulario;
    meusdados[e.target.name] = e.target.value;
    setCamposFormularios({ ...meusdados });
  }

  return (
    <div id="credenciados">
      <div id="head"></div>
      <div id="formg">
        <div className="content">
          <div className="row">
            <div className="col-lg-6 col-md-12 left-form">
              <FormContent props={propsFormContent} />
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="box-form row no-gutters form animated fadeIn">
                <div className="col-12 row no-gutters infos">
                  <img width="203" height="59" alt="" src={Logo} />
                  <p className="font-16">
                    A qualidade de vida que sua família merece não precisa
                    custar caro!
                    <br />
                    <b className="cl-light-blue">
                      Não fazemos análise de Perfil.
                    </b>
                  </p>
                </div>
                <div className="col-12 row no-gutters">
                  <form
                    className="col-12 row "
                    onSubmit={handleSend}
                    method="post"
                  >
                    <div className="col-12">
                      <select
                        name="plano"
                        required
                        value={menuPlano}
                        onChange={(e) => {
                          setmenuPlano(e.target.value);
                          changeInputMult(e);
                        }}
                      >
                        <option>Plano</option>
                        <option value="PLANO_SAUDEESSENCIAL">
                          Super Essencial |{" "}
                          {planPrices !== undefined &&
                            Number(planPrices[0]).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          /mensais
                        </option>
                        <option value="PLANO_SAUDEPLUS">
                          Super Saude+ |{" "}
                          {planPrices !== undefined &&
                            Number(planPrices[1]).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          /mensais
                        </option>
                        <option value="PLANO_SAUDEPREMIUM">
                          Super Premium |{" "}
                          {planPrices !== undefined &&
                            Number(planPrices[2]).toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                          /mensais
                        </option>
                      </select>
                    </div>
                    <div className="col-12">
                      <input
                        type="text"
                        required
                        value={camposFormulario.nome}
                        onChange={(e) => changeInputMult(e)}
                        name="nome"
                        placeholder="Nome completo"
                      />
                    </div>

                    <div className="col-lg-6 col-md-12">
                      <InputMask
                        mask="(99) 99999-9999"
                        required
                        type="text"
                        value={camposFormulario.telefone}
                        onChange={(e) => changeInputMult(e)}
                        name="telefone"
                        placeholder="Telefone"
                      />
                    </div>

                    <div className="col-lg-6 col-md-12" align="right">
                      <input
                        type="text"
                        required
                        value={camposFormulario.email}
                        onChange={(e) => changeInputMult(e)}
                        name="email"
                        placeholder="E-mail"
                      />
                    </div>

                    <div className="ipt-check col-12">
                      <button type="submit">
                        {stepLoad === true ? (
                          <FiLoader />
                        ) : (
                          "Quero mais informações"
                        )}{" "}
                        <img width="24" height="24" alt="" src={ArrowYellow} />{" "}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
